import { useSelector } from 'react-redux';

import { createOrUpdateBorrower } from '@/apiCalls/borrower';
import { DisplayButtons } from '@/components/DisplayButtons';
import {
    selectAddressByIndex,
    selectEmail,
    selectFirstName,
    selectLastName,
    selectLicenseNumber,
    selectLicenseState,
} from '@/context/borrower';
import { EDisplays, EModals, setDisplay, setModal } from '@/context/display';
import { RootState } from '@/context/store';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { isBirthDateValid } from '@/utils/checkBirthDate';
import { isLicenseExpiryDateValid } from '@/utils/checkLicenseExpiryDate';
import { isEmail } from '@/utils/isEmail';

interface IOcrSummaryButtonsProps {
    setShowErrors: (value: boolean) => void;
    baseId?: string;
}

export function TDOcrSummaryButtons({
    setShowErrors,
    baseId,
}: IOcrSummaryButtonsProps): JSX.Element {
    // ***** Redux State *****
    const dispatch = useAppDispatch();
    // Contact Details
    const firstName = useAppSelector(selectFirstName);
    const lastName = useAppSelector(selectLastName);
    const email = useAppSelector(selectEmail);
    // Personal Information
    const licenseNumber = useAppSelector(selectLicenseNumber);
    const licenseState = useAppSelector(selectLicenseState);
    // Address Information
    const address = useSelector((state: RootState) =>
        selectAddressByIndex(state, 0)
    );
    const { streetNumber, streetName, suburb, state, postcode } = address;

    function isComplete(): boolean {
        // Contact Details
        if (firstName === '' || firstName === undefined) return false;
        if (lastName === '' || lastName === undefined) return false;
        if (!isEmail(email)) return false;

        // Personal Information
        if (!isBirthDateValid()) return false;

        if (licenseNumber === '' || licenseNumber === undefined) return false;
        if (licenseState === '' || licenseState === undefined) return false;

        if (!isLicenseExpiryDateValid()) return false;

        // Address Information
        if (streetNumber === '' || streetNumber === undefined) return false;
        if (streetName === '' || streetName === undefined) return false;
        if (suburb === '' || suburb === undefined) return false;
        if (state === null || state === undefined) return false;
        if (
            postcode === '' ||
            postcode === null ||
            postcode === undefined ||
            postcode.toString().length < 4
        ) {
            return false;
        }
        console.log('4');

        return true;
    }
    function handleBackClick(): void {
        dispatch(setDisplay(EDisplays.IDENTIFICATION));
    }

    function handleNextClick(): void {
        setShowErrors(true);
        if (!isComplete()) {
            dispatch(setModal(EModals.OCR_CHECK_INCOMPLETE));
            return;
        }
        dispatch(setDisplay(EDisplays.TEST_DRIVE_AGREEMENT));
        createOrUpdateBorrower();
        return;
    }

    return (
        <DisplayButtons
            idLeftButton={`${baseId}-button-back`}
            idRightButton={`${baseId}-button-next`}
            rightClick={handleNextClick}
            leftClick={handleBackClick}
        />
    );
}
